import React from "react";
import CategoryFrom from "../../components/categoryes/categoryForm/CategoryForm";
import CatigoryesList from "../../components/categoryes/catigoryesList/catigoryesLisy.component";

function Categores() {
  return (
    <>
      <div>
        <CategoryFrom />
      </div>
      <div>
        <CatigoryesList />
      </div>
    </>
  );
}

export default Categores;
